import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = { isLoading: false, data: {}, errors: [] };

export const getContentCreators = createAsyncThunk('contentCreators/getContentCreators', async (args, thunkApi) => {
  try {
    const { page = 1, size = 10, query = '', filter = JSON.stringify({}) } = args || {};
    const { data } = await axios.get(
      `/api/get_content_creators?page=${page}&size=${size}&query=${query}&filter=${filter}`
    );
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue(
      errors.response?.status !== 400 ? { errors: [{ msg: 'something went wrong' }] } : errors.response.data
    );
  }
});

export const createContentCreator = createAsyncThunk('contentCreators/createContentCreator', async (args, thunkApi) => {
  try {
    const { data } = await axios.post('/api/create_content_creator', args, {
      headers: { Authorization: thunkApi.getState().auth.token }
    });
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue(
      errors.response?.status !== 400 ? { errors: [{ msg: 'something went wrong' }] } : errors.response.data
    );
  }
});

export const updateContentCreator = createAsyncThunk('contentCreators/updateContentCreator', async (args, thunkApi) => {
  try {
    const id = args.get ? args.get('_id') : args._id;
    const { data } = await axios.put(`/api/update_content_creator/${id}`, args, {
      headers: { Authorization: thunkApi.getState().auth.token }
    });
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue(
      errors.response?.status !== 400 ? { errors: [{ msg: 'something went wrong' }] } : errors.response.data
    );
  }
});

export const deleteContentCreator = createAsyncThunk('contentCreators/deleteContentCreator', async (args, thunkApi) => {
  try {
    const { data } = await axios.delete(`/api/delete_content_creator/${args._id}`, {
      headers: { Authorization: thunkApi.getState().auth.token }
    });
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue(
      errors.response?.status !== 400 ? { errors: [{ msg: 'something went wrong' }] } : errors.response.data
    );
  }
});

const contentCreatorsSlice = createSlice({
  name: 'contentCreators',
  initialState,
  extraReducers: {
    [getContentCreators.pending]: (state) => { state.isLoading = true; state.errors = []; },
    [getContentCreators.fulfilled]: (state, action) => { state.isLoading = false; state.data = action.payload; },
    [getContentCreators.rejected]: (state, action) => { state.isLoading = false; state.data = {}; state.errors = action.payload.errors; },

    [createContentCreator.pending]: (state) => { state.isLoading = true; state.errors = []; },
    [createContentCreator.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.data.itemsCount = (state.data.itemsCount || 0) + 1;
      if ((state.data.data?.length || 0) < 10) state.data.data = [...(state.data.data || []), action.payload.data];
    },
    [createContentCreator.rejected]: (state, action) => { state.isLoading = false; state.errors = action.payload.errors; },

    [updateContentCreator.pending]: (state) => { state.isLoading = true; state.errors = []; },
    [updateContentCreator.fulfilled]: (state, action) => {
      state.isLoading = false;
      const idx = state.data.data?.findIndex(el => el._id === action.payload.data._id);
      if (idx !== undefined && idx >= 0) state.data.data[idx] = action.payload.data;
    },
    [updateContentCreator.rejected]: (state, action) => { state.isLoading = false; state.errors = action.payload.errors; },

    [deleteContentCreator.pending]: (state) => { state.isLoading = true; state.errors = []; },
    [deleteContentCreator.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.data.data = state.data.data?.filter(el => el._id !== action.payload.data._id);
      state.data.itemsCount = Math.max(0, (state.data.itemsCount || 1) - 1);
    },
    [deleteContentCreator.rejected]: (state, action) => { state.isLoading = false; state.errors = action.payload.errors; },
  }
});

export default contentCreatorsSlice.reducer;
